class VideoPlayer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initVideo()
  }
  initVideo() {
    // let video = this.querySelector("video") || this.querySelector(".plyr__video-embed");

    let videos_desktop = document.querySelectorAll("video-player.video-des");
    let videos_mobile = document.querySelectorAll("video-player.video-mb");
    let video;
    if(window.innerWidth >= 1024) {
      video = this.querySelectorAll("video-player.video-des video") || this.querySelectorAll(".plyr__video-embed");
      for (const element_mob of videos_mobile) {
        element_mob.remove()
      }
    } else {
      video = this.querySelectorAll("video-player.video-mb video") || this.querySelectorAll(".plyr__video-embed");
      for (const element_des of videos_desktop) {
        element_des.remove()
      }
    }
    if(!video) return;
    // console.log(video);
    this.video = new Plyr(video, {
      controls: ["play", "progress", "mute", "volume", (window.innerWidth < 1024 ? "" : "fullscreen")],
      autoplay: true,
      muted: true,
      volume: 0,
      hideControls: false,
      vimeo: { byline: true, portrait: false, title: false, controls: false, autoplay: true, muted: true, loop: true },
    });
    this.video.volume= 0
    this.video.muted= true
    this.video.autoplay= true
    this.video.loop= true
    // window.addEventListener("resize", ()=>{
    //     this.video.pause()
    // });
    this.video.on("ready", () => {
        setTimeout(() => {
          this.video.play();
        }, 500);
        // window.addEventListener("scroll", ()=>{
        //   if(this.video.paused == true) {
        //     console.log(this.video.paused);
        //     this.video.play();
        //   }
        // });
    });
  }
}
if (!customElements.get("video-player")) {
  customElements.define("video-player", VideoPlayer);
}